import { isInIframe } from "@repo/ui/helpers/helpers";

export const POPUP_AUTH_CALLBACK_QUERY_PARAM_NAME = "popupAuthCallback";

/**
 * Whether auth has to run in a popup instead of a top-level redirect. Being
 * framed is the real condition — IdPs refuse to be framed, so redirecting the
 * frame dead-ends — but the sign-in screen has long treated the Fountain marker
 * as sufficient on its own, so keep both triggers.
 */
export function requiresPopupAuth(): boolean {
  const queryParams = new URLSearchParams(window.location.search);
  const isComingFromFountain = queryParams.get("int") === "fountain";
  return isComingFromFountain || isInIframe();
}

// Used to open the relevant login page (Google/Azure/SSO) in a popup so auth still works
// when we are embedded in an iframe (e.g. Fountain)
export function openAuthPopup(url: string): Window | null {
  const width = 600;
  const height = 700;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;
  return window.open(
    url,
    "Auth Popup",
    `width=${String(width)},height=${String(height)},left=${String(left)},top=${String(top)},popup=1`,
  );
}

let isPopupAuthCallback: boolean | null = null;

// Check if we are on the callback page for the popup auth flow (i.e. embedded in Fountain)
export function getIsPopupAuthCallback(): boolean {
  if (isPopupAuthCallback !== null) {
    return isPopupAuthCallback;
  }

  if (typeof window === "undefined") {
    isPopupAuthCallback = false;
    return false;
  }

  const searchParams = new URLSearchParams(window.location.search);
  isPopupAuthCallback =
    searchParams.get(POPUP_AUTH_CALLBACK_QUERY_PARAM_NAME) === "true";

  return isPopupAuthCallback;
}
